import { Outlet } from 'react-router-dom';

export function AnimatedLayout() {
  return (
    <div className='relative h-full w-full overflow-hidden md:overflow-hidden'>
      <div className='absolute inset-0 md:absolute md:inset-0'>
        <Outlet />
      </div>
    </div>
  );
}

export default AnimatedLayout;
